export enum ReminderBadgeColors {
  Danger = 'danger',
  Primary = 'primary',
}
